"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Integration = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preact = require("preact");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Integration = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Integration, _Component);

  var _super = _createSuper(Integration);

  function Integration(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, Integration);
    _this = _super.call(this, props, context);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "displayUnsavedChangedModal", function () {
      _this.setState({
        showUnsavedChangesModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeUninstallModal", function () {
      _this.setState({
        showUninstallModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeModal", function () {
      _this.setState({
        showUnsavedChangesModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setActivePanel", function (selectedPanel) {
      _this.setState({
        selectedPanel: selectedPanel
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setActiveTab", function (selectedTab) {
      if (_this.checkPanelHasUnsavedChanges()) {
        _this.setState({
          showUnsavedChangesModal: true,
          selectedTab: selectedTab
        });

        return;
      }

      _this.setState({
        activeTab: selectedTab,
        selectedTab: selectedTab
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeValidationErrorFromInputField", function (inputField) {
      var _this$state$errorFiel, _this$state$errorFiel2;

      if (((_this$state$errorFiel = _this.state.errorFields) === null || _this$state$errorFiel === void 0 ? void 0 : _this$state$errorFiel.length) === 0) {
        return;
      }

      var fields = (_this$state$errorFiel2 = _this.state.errorFields) === null || _this$state$errorFiel2 === void 0 ? void 0 : _this$state$errorFiel2.filter(function (value) {
        return value.field !== inputField;
      });

      _this.setState({
        errorFields: fields
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isInputInvalid", function (validatedFields) {
      if (validatedFields.length !== 0) {
        _this.setState({
          errorFields: validatedFields,
          isSavingCredentials: false
        });

        return true;
      }

      return false;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickUninstallButton", function () {
      _this.setState({
        showUninstallModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setSelectedPanel", function (selectedPanel) {
      _this.setState({
        selectedPanel: selectedPanel
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFederatedSearchSettingChanged", function (value) {
      _this.setState({
        isFederatedSearchActive: value,
        showFederatedSearchActionButtons: true
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Integration, [{
    key: "getBaseInitialState",
    value: function getBaseInitialState() {
      return {
        activeTab: 0,
        showUnsavedChangesModal: false,
        showUninstallModal: false,
        isFederatedSearchActive: false,
        showFederatedSearchActionButtons: false
      };
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this2 = this;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                window.addEventListener('beforeunload', function (e) {
                  return _this2.onUnload(e);
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.onUnload);
    }
  }, {
    key: "onUnload",
    value: function onUnload(e) {
      if (this.checkPanelHasUnsavedChanges()) {
        e.preventDefault();
        e.returnValue = '';
      }
    }
  }, {
    key: "resetMessages",
    value: function resetMessages() {
      this.setState({
        messageType: undefined,
        errorFields: [],
        isSavingCredentials: true
      });
    }
  }]);
  return Integration;
}(_preact.Component);

exports.Integration = Integration;